import CastingProfile from './CastingProfile.Container';

export default CastingProfile;
